import { render, staticRenderFns } from "./GChatInputarea.vue?vue&type=template&id=0b9c0548&"
import script from "./GChatInputarea.vue?vue&type=script&lang=ts&"
export * from "./GChatInputarea.vue?vue&type=script&lang=ts&"
import style0 from "./GChatInputarea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports